// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Instrument+Serif:ital,wght@0,400;1,400&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.docs-page {
  color: var(--color-text-primary);
  padding: 32px 24px 96px;
}

.docs-page__inner {
  max-width: 1180px;
  margin: 0 auto;
}

.docs-page__breadcrumb {
  margin-bottom: 18px;
}

.docs-page__breadcrumb ol {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0;
  list-style: none;
  margin: 0;
  padding: 0;
  font-size: 0.82rem;
  color: var(--color-text-secondary);
}

.docs-page__breadcrumb li {
  display: flex;
  align-items: center;
}

.docs-page__breadcrumb li:not(:last-child)::after {
  content: "/";
  margin: 0 8px;
  color: var(--color-text-secondary);
  opacity: 0.55;
}

.docs-page__breadcrumb a {
  color: var(--color-text-secondary);
  text-decoration: none;
}

.docs-page__breadcrumb a:hover {
  color: var(--color-accent-base);
}

.docs-page__hero {
  border: 1px solid var(--color-border-input);
  border-radius: 18px;
  background: var(--color-bg-canvas-surface);
  padding: 34px 38px;
  box-shadow: var(--color-shadow-canvas-frame);
}

.docs-page__eyebrow,
.docs-page__section-label {
  margin: 0 0 10px;
  color: var(--color-accent-base);
  text-transform: uppercase;
  letter-spacing: 0.08em;
  font-size: 0.72rem;
  font-weight: 700;
}

.docs-page__title {
  margin: 0;
  font-family: 'Geist Sans', 'Times New Roman', serif;
  font-size: clamp(2.45rem, 6vw, 4.7rem);
  font-weight: 400;
  line-height: 0.98;
  letter-spacing: -0.025em;
}

.docs-page__description {
  max-width: 760px;
  margin: 20px 0 0;
  color: var(--color-text-secondary);
  line-height: 1.7;
  font-size: 1.06rem;
}

.docs-page__meta-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  margin-top: 22px;
  color: var(--color-text-secondary);
  font-size: 0.84rem;
}

.docs-page__meta-row span:not(:last-child)::after {
  content: "·";
  margin-left: 8px;
  opacity: 0.55;
}

.docs-page__quick-start {
  margin-top: 28px;
}

.docs-page__section-title {
  margin: 0 0 16px;
  font-family: 'Geist Sans', 'Times New Roman', serif;
  font-weight: 400;
  font-size: 1.85rem;
  line-height: 1.15;
}

.docs-page__quick-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
}

.docs-page__quick-card {
  display: flex;
  flex-direction: column;
  min-height: 142px;
  border: 1px solid var(--color-border-input);
  border-radius: 14px;
  background: var(--color-bg-canvas-surface);
  padding: 16px;
  color: inherit;
  text-decoration: none;
  transition: border-color 0.15s ease, background 0.15s ease;
}

.docs-page__quick-card:hover {
  border-color: var(--color-accent-base);
  background: color-mix(in srgb, var(--color-bg-canvas-surface) 88%, var(--color-bg-user-bubble));
}

.docs-page__quick-card h3 {
  margin: 0;
  font-size: 0.98rem;
  line-height: 1.35;
}

.docs-page__quick-card p {
  margin: 8px 0 0;
  color: var(--color-text-secondary);
  line-height: 1.55;
  font-size: 0.9rem;
}

.docs-page__quick-arrow {
  margin-top: auto;
  padding-top: 14px;
  color: var(--color-accent-base);
  font-weight: 700;
}

.docs-page__layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 280px;
  gap: 24px;
  align-items: start;
  margin-top: 28px;
}

.docs-page__article {
  min-width: 0;
  border: 1px solid var(--color-border-input);
  border-radius: 18px;
  background: var(--color-bg-canvas-surface);
  padding: 36px 42px;
  box-shadow: var(--color-shadow-canvas-frame);
}

.docs-page__toc {
  position: sticky;
  top: 76px;
  border: 1px solid var(--color-border-input);
  border-radius: 14px;
  background: var(--color-bg-canvas-surface);
  padding: 16px;
  box-shadow: var(--color-shadow-canvas-frame);
}

.docs-page__toc-title {
  margin: 0 0 12px;
  font-size: 0.78rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--color-text-secondary);
}

.docs-page__toc-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: grid;
  gap: 2px;
}

.docs-page__toc-link {
  display: block;
  padding: 7px 8px;
  border-radius: 7px;
  color: var(--color-text-secondary);
  text-decoration: none;
  font-size: 0.86rem;
  line-height: 1.35;
}

.docs-page__toc-link:hover {
  background: var(--color-bg-user-bubble);
  color: var(--color-text-primary);
}

.docs-page__toc-cta {
  display: block;
  margin-top: 14px;
  border-top: 1px solid var(--color-border-input);
  padding: 14px 8px 2px;
  color: var(--color-accent-base);
  font-size: 0.86rem;
  font-weight: 700;
  text-decoration: none;
}

.docs-page__content {
  line-height: 1.72;
  font-size: 1rem;
}

.docs-page__content > :first-child {
  margin-top: 0;
}

.docs-page__content h1,
.docs-page__content h2,
.docs-page__content h3,
.docs-page__content h4 {
  scroll-margin-top: 86px;
  line-height: 1.22;
  letter-spacing: -0.006em;
}

.docs-page__content h1,
.docs-page__content h2 {
  font-family: 'Geist Sans', 'Times New Roman', serif;
  font-weight: 400;
}

.docs-page__content h1 {
  font-size: 2rem;
  margin: 0 0 1rem;
}

.docs-page__content h2 {
  margin: 2.5rem 0 0.9rem;
  padding-bottom: 0.55rem;
  border-bottom: 1px solid var(--color-border-input);
  font-size: 1.65rem;
}

.docs-page__content h3 {
  margin: 1.7rem 0 0.65rem;
  font-size: 1.15rem;
}

.docs-page__content h4 {
  margin: 1.35rem 0 0.45rem;
  font-size: 1rem;
}

.docs-page__content p,
.docs-page__content ul,
.docs-page__content ol,
.docs-page__content blockquote,
.docs-page__content table,
.docs-page__content pre {
  margin: 0 0 1.1rem;
}

.docs-page__content ul,
.docs-page__content ol {
  padding-left: 1.35rem;
}

.docs-page__content li {
  margin-bottom: 0.28rem;
}

.docs-page__content a {
  color: var(--color-accent-base);
  text-decoration: none;
  border-bottom: 1px solid color-mix(in srgb, var(--color-accent-base) 45%, transparent);
}

.docs-page__content a:hover {
  border-bottom-color: var(--color-accent-base);
}

.docs-page__content blockquote {
  border: 1px solid var(--color-border-input);
  border-left: 3px solid var(--color-accent-base);
  border-radius: 10px;
  padding: 0.9rem 1rem;
  color: var(--color-text-secondary);
  background: var(--color-bg-user-bubble);
}

.docs-page__content code {
  font-family: "SFMono-Regular", Menlo, Consolas, "Liberation Mono", monospace;
  font-size: 0.88em;
  background: var(--color-bg-user-bubble);
  border: 1px solid var(--color-border-input);
  border-radius: 5px;
  padding: 0.1rem 0.34rem;
}

.docs-page__content pre {
  overflow-x: auto;
  background: var(--color-bg-canvas-frame);
  border: 1px solid var(--color-border-input);
  border-radius: 12px;
  padding: 1rem;
}

.docs-page__content pre code {
  background: transparent;
  border: 0;
  padding: 0;
}

.docs-page__content table {
  display: block;
  width: 100%;
  overflow-x: auto;
  border-collapse: collapse;
  border: 1px solid var(--color-border-input);
  border-radius: 10px;
}

.docs-page__content th,
.docs-page__content td {
  border-bottom: 1px solid var(--color-border-input);
  padding: 10px 12px;
  text-align: left;
  vertical-align: top;
  min-width: 150px;
}

.docs-page__content th {
  background: var(--color-bg-user-bubble);
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.045em;
}

.docs-page__content tr:last-child td {
  border-bottom: 0;
}

.docs-page__content img {
  display: block;
  width: 100%;
  max-width: 100%;
  height: auto;
  margin: 1.4rem 0 1.55rem;
  border: 1px solid var(--color-border-input);
  border-radius: 14px;
  background: var(--color-bg-canvas-frame);
}

.docs-page__content hr {
  border: 0;
  border-top: 1px solid var(--color-border-input);
  margin: 2rem 0;
}

.docs-page__status {
  min-height: 420px;
}

.docs-page__skeleton {
  height: 16px;
  border-radius: 999px;
  background: var(--color-bg-canvas-frame);
  margin-bottom: 14px;
  animation: docs-skeleton-pulse 1.4s ease-in-out infinite;
}

.docs-page__skeleton--short {
  width: 62%;
}

.docs-page__skeleton--medium {
  width: 82%;
}

@keyframes docs-skeleton-pulse {
  0%, 100% { opacity: 0.5; }
  50% { opacity: 1; }
}

.docs-page__status--error {
  color: var(--color-status-error-text);
}

.docs-page__cta {
  margin-top: 28px;
  border: 1px solid var(--color-border-input);
  border-radius: 18px;
  background: var(--color-bg-canvas-surface);
  padding: 26px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  box-shadow: var(--color-shadow-canvas-frame);
}

.docs-page__cta h2 {
  margin: 0;
  font-family: 'Geist Sans', 'Times New Roman', serif;
  font-weight: 400;
  font-size: 1.75rem;
}

.docs-page__cta p {
  margin: 0 0 8px;
  color: var(--color-text-secondary);
  line-height: 1.55;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  font-size: 0.72rem;
  font-weight: 700;
}

.docs-page__cta-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  flex-shrink: 0;
}

.docs-page__button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 38px;
  border: 1px solid var(--color-border-input);
  border-radius: 8px;
  padding: 0 14px;
  color: var(--color-text-primary);
  background: var(--color-bg-input);
  text-decoration: none;
  font-size: 0.9rem;
  font-weight: 700;
}

.docs-page__button:hover {
  background: var(--color-bg-user-bubble);
}

.docs-page__button--secondary {
  background: transparent;
  color: var(--color-text-secondary);
}

@media (max-width: 980px) {
  .docs-page__quick-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .docs-page__layout {
    grid-template-columns: 1fr;
  }

  .docs-page__toc {
    position: static;
    order: -1;
  }

  .docs-page__toc-list {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 680px) {
  .docs-page {
    padding: 22px 14px 72px;
  }

  .docs-page__hero,
  .docs-page__article,
  .docs-page__cta {
    border-radius: 14px;
    padding: 22px;
  }

  .docs-page__quick-grid,
  .docs-page__toc-list {
    grid-template-columns: 1fr;
  }

  .docs-page__layout {
    gap: 16px;
  }

  .docs-page__cta {
    align-items: flex-start;
    flex-direction: column;
  }

  .docs-page__cta-actions {
    width: 100%;
  }

  .docs-page__button {
    flex: 1 1 auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/DocsPage.css"],"names":[],"mappings":"AAEA;EACE,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,MAAM;EACN,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kCAAkC;EAClC,aAAa;AACf;;AAEA;EACE,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;EACnB,0CAA0C;EAC1C,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;;EAEE,gBAAgB;EAChB,+BAA+B;EAC/B,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,mDAAmD;EACnD,sCAAsC;EACtC,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;EAChB,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mDAAmD;EACnD,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,2CAA2C;EAC3C,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,cAAc;EACd,qBAAqB;EACrB,0DAA0D;AAC5D;;AAEA;EACE,sCAAsC;EACtC,+FAA+F;AACjG;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,2CAA2C;EAC3C,mBAAmB;EACnB,0CAA0C;EAC1C,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,2CAA2C;EAC3C,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;EAClC,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,+CAA+C;EAC/C,qBAAqB;EACrB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;;;;EAIE,uBAAuB;EACvB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;;EAEE,mDAAmD;EACnD,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,kDAAkD;EAClD,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;;;;;EAME,kBAAkB;AACpB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,sFAAsF;AACxF;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,2CAA2C;EAC3C,+CAA+C;EAC/C,mBAAmB;EACnB,oBAAoB;EACpB,kCAAkC;EAClC,uCAAuC;AACzC;;AAEA;EACE,4EAA4E;EAC5E,iBAAiB;EACjB,uCAAuC;EACvC,2CAA2C;EAC3C,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,wCAAwC;EACxC,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;;EAEE,kDAAkD;EAClD,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,iBAAiB;EACjB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,YAAY;EACZ,wBAAwB;EACxB,2CAA2C;EAC3C,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,SAAS;EACT,+CAA+C;EAC/C,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,wCAAwC;EACxC,mBAAmB;EACnB,wDAAwD;AAC1D;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW,YAAY,EAAE;EACzB,MAAM,UAAU,EAAE;AACpB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,2CAA2C;EAC3C,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,4CAA4C;AAC9C;;AAEA;EACE,SAAS;EACT,mDAAmD;EACnD,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,2CAA2C;EAC3C,kBAAkB;EAClB,eAAe;EACf,gCAAgC;EAChC,iCAAiC;EACjC,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA;EACE;IACE,gDAAgD;EAClD;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;IAChB,SAAS;EACX;;EAEA;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;;;IAGE,mBAAmB;IACnB,aAAa;EACf;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Instrument+Serif:ital,wght@0,400;1,400&display=swap');\n\n.docs-page {\n  color: var(--color-text-primary);\n  padding: 32px 24px 96px;\n}\n\n.docs-page__inner {\n  max-width: 1180px;\n  margin: 0 auto;\n}\n\n.docs-page__breadcrumb {\n  margin-bottom: 18px;\n}\n\n.docs-page__breadcrumb ol {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 0;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  font-size: 0.82rem;\n  color: var(--color-text-secondary);\n}\n\n.docs-page__breadcrumb li {\n  display: flex;\n  align-items: center;\n}\n\n.docs-page__breadcrumb li:not(:last-child)::after {\n  content: \"/\";\n  margin: 0 8px;\n  color: var(--color-text-secondary);\n  opacity: 0.55;\n}\n\n.docs-page__breadcrumb a {\n  color: var(--color-text-secondary);\n  text-decoration: none;\n}\n\n.docs-page__breadcrumb a:hover {\n  color: var(--color-accent-base);\n}\n\n.docs-page__hero {\n  border: 1px solid var(--color-border-input);\n  border-radius: 18px;\n  background: var(--color-bg-canvas-surface);\n  padding: 34px 38px;\n  box-shadow: var(--color-shadow-canvas-frame);\n}\n\n.docs-page__eyebrow,\n.docs-page__section-label {\n  margin: 0 0 10px;\n  color: var(--color-accent-base);\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  font-size: 0.72rem;\n  font-weight: 700;\n}\n\n.docs-page__title {\n  margin: 0;\n  font-family: 'Geist Sans', 'Times New Roman', serif;\n  font-size: clamp(2.45rem, 6vw, 4.7rem);\n  font-weight: 400;\n  line-height: 0.98;\n  letter-spacing: -0.025em;\n}\n\n.docs-page__description {\n  max-width: 760px;\n  margin: 20px 0 0;\n  color: var(--color-text-secondary);\n  line-height: 1.7;\n  font-size: 1.06rem;\n}\n\n.docs-page__meta-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  align-items: center;\n  margin-top: 22px;\n  color: var(--color-text-secondary);\n  font-size: 0.84rem;\n}\n\n.docs-page__meta-row span:not(:last-child)::after {\n  content: \"·\";\n  margin-left: 8px;\n  opacity: 0.55;\n}\n\n.docs-page__quick-start {\n  margin-top: 28px;\n}\n\n.docs-page__section-title {\n  margin: 0 0 16px;\n  font-family: 'Geist Sans', 'Times New Roman', serif;\n  font-weight: 400;\n  font-size: 1.85rem;\n  line-height: 1.15;\n}\n\n.docs-page__quick-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 10px;\n}\n\n.docs-page__quick-card {\n  display: flex;\n  flex-direction: column;\n  min-height: 142px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 14px;\n  background: var(--color-bg-canvas-surface);\n  padding: 16px;\n  color: inherit;\n  text-decoration: none;\n  transition: border-color 0.15s ease, background 0.15s ease;\n}\n\n.docs-page__quick-card:hover {\n  border-color: var(--color-accent-base);\n  background: color-mix(in srgb, var(--color-bg-canvas-surface) 88%, var(--color-bg-user-bubble));\n}\n\n.docs-page__quick-card h3 {\n  margin: 0;\n  font-size: 0.98rem;\n  line-height: 1.35;\n}\n\n.docs-page__quick-card p {\n  margin: 8px 0 0;\n  color: var(--color-text-secondary);\n  line-height: 1.55;\n  font-size: 0.9rem;\n}\n\n.docs-page__quick-arrow {\n  margin-top: auto;\n  padding-top: 14px;\n  color: var(--color-accent-base);\n  font-weight: 700;\n}\n\n.docs-page__layout {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 280px;\n  gap: 24px;\n  align-items: start;\n  margin-top: 28px;\n}\n\n.docs-page__article {\n  min-width: 0;\n  border: 1px solid var(--color-border-input);\n  border-radius: 18px;\n  background: var(--color-bg-canvas-surface);\n  padding: 36px 42px;\n  box-shadow: var(--color-shadow-canvas-frame);\n}\n\n.docs-page__toc {\n  position: sticky;\n  top: 76px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 14px;\n  background: var(--color-bg-canvas-surface);\n  padding: 16px;\n  box-shadow: var(--color-shadow-canvas-frame);\n}\n\n.docs-page__toc-title {\n  margin: 0 0 12px;\n  font-size: 0.78rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: var(--color-text-secondary);\n}\n\n.docs-page__toc-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: grid;\n  gap: 2px;\n}\n\n.docs-page__toc-link {\n  display: block;\n  padding: 7px 8px;\n  border-radius: 7px;\n  color: var(--color-text-secondary);\n  text-decoration: none;\n  font-size: 0.86rem;\n  line-height: 1.35;\n}\n\n.docs-page__toc-link:hover {\n  background: var(--color-bg-user-bubble);\n  color: var(--color-text-primary);\n}\n\n.docs-page__toc-cta {\n  display: block;\n  margin-top: 14px;\n  border-top: 1px solid var(--color-border-input);\n  padding: 14px 8px 2px;\n  color: var(--color-accent-base);\n  font-size: 0.86rem;\n  font-weight: 700;\n  text-decoration: none;\n}\n\n.docs-page__content {\n  line-height: 1.72;\n  font-size: 1rem;\n}\n\n.docs-page__content > :first-child {\n  margin-top: 0;\n}\n\n.docs-page__content h1,\n.docs-page__content h2,\n.docs-page__content h3,\n.docs-page__content h4 {\n  scroll-margin-top: 86px;\n  line-height: 1.22;\n  letter-spacing: -0.006em;\n}\n\n.docs-page__content h1,\n.docs-page__content h2 {\n  font-family: 'Geist Sans', 'Times New Roman', serif;\n  font-weight: 400;\n}\n\n.docs-page__content h1 {\n  font-size: 2rem;\n  margin: 0 0 1rem;\n}\n\n.docs-page__content h2 {\n  margin: 2.5rem 0 0.9rem;\n  padding-bottom: 0.55rem;\n  border-bottom: 1px solid var(--color-border-input);\n  font-size: 1.65rem;\n}\n\n.docs-page__content h3 {\n  margin: 1.7rem 0 0.65rem;\n  font-size: 1.15rem;\n}\n\n.docs-page__content h4 {\n  margin: 1.35rem 0 0.45rem;\n  font-size: 1rem;\n}\n\n.docs-page__content p,\n.docs-page__content ul,\n.docs-page__content ol,\n.docs-page__content blockquote,\n.docs-page__content table,\n.docs-page__content pre {\n  margin: 0 0 1.1rem;\n}\n\n.docs-page__content ul,\n.docs-page__content ol {\n  padding-left: 1.35rem;\n}\n\n.docs-page__content li {\n  margin-bottom: 0.28rem;\n}\n\n.docs-page__content a {\n  color: var(--color-accent-base);\n  text-decoration: none;\n  border-bottom: 1px solid color-mix(in srgb, var(--color-accent-base) 45%, transparent);\n}\n\n.docs-page__content a:hover {\n  border-bottom-color: var(--color-accent-base);\n}\n\n.docs-page__content blockquote {\n  border: 1px solid var(--color-border-input);\n  border-left: 3px solid var(--color-accent-base);\n  border-radius: 10px;\n  padding: 0.9rem 1rem;\n  color: var(--color-text-secondary);\n  background: var(--color-bg-user-bubble);\n}\n\n.docs-page__content code {\n  font-family: \"SFMono-Regular\", Menlo, Consolas, \"Liberation Mono\", monospace;\n  font-size: 0.88em;\n  background: var(--color-bg-user-bubble);\n  border: 1px solid var(--color-border-input);\n  border-radius: 5px;\n  padding: 0.1rem 0.34rem;\n}\n\n.docs-page__content pre {\n  overflow-x: auto;\n  background: var(--color-bg-canvas-frame);\n  border: 1px solid var(--color-border-input);\n  border-radius: 12px;\n  padding: 1rem;\n}\n\n.docs-page__content pre code {\n  background: transparent;\n  border: 0;\n  padding: 0;\n}\n\n.docs-page__content table {\n  display: block;\n  width: 100%;\n  overflow-x: auto;\n  border-collapse: collapse;\n  border: 1px solid var(--color-border-input);\n  border-radius: 10px;\n}\n\n.docs-page__content th,\n.docs-page__content td {\n  border-bottom: 1px solid var(--color-border-input);\n  padding: 10px 12px;\n  text-align: left;\n  vertical-align: top;\n  min-width: 150px;\n}\n\n.docs-page__content th {\n  background: var(--color-bg-user-bubble);\n  font-size: 0.8rem;\n  text-transform: uppercase;\n  letter-spacing: 0.045em;\n}\n\n.docs-page__content tr:last-child td {\n  border-bottom: 0;\n}\n\n.docs-page__content img {\n  display: block;\n  width: 100%;\n  max-width: 100%;\n  height: auto;\n  margin: 1.4rem 0 1.55rem;\n  border: 1px solid var(--color-border-input);\n  border-radius: 14px;\n  background: var(--color-bg-canvas-frame);\n}\n\n.docs-page__content hr {\n  border: 0;\n  border-top: 1px solid var(--color-border-input);\n  margin: 2rem 0;\n}\n\n.docs-page__status {\n  min-height: 420px;\n}\n\n.docs-page__skeleton {\n  height: 16px;\n  border-radius: 999px;\n  background: var(--color-bg-canvas-frame);\n  margin-bottom: 14px;\n  animation: docs-skeleton-pulse 1.4s ease-in-out infinite;\n}\n\n.docs-page__skeleton--short {\n  width: 62%;\n}\n\n.docs-page__skeleton--medium {\n  width: 82%;\n}\n\n@keyframes docs-skeleton-pulse {\n  0%, 100% { opacity: 0.5; }\n  50% { opacity: 1; }\n}\n\n.docs-page__status--error {\n  color: var(--color-status-error-text);\n}\n\n.docs-page__cta {\n  margin-top: 28px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 18px;\n  background: var(--color-bg-canvas-surface);\n  padding: 26px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 18px;\n  box-shadow: var(--color-shadow-canvas-frame);\n}\n\n.docs-page__cta h2 {\n  margin: 0;\n  font-family: 'Geist Sans', 'Times New Roman', serif;\n  font-weight: 400;\n  font-size: 1.75rem;\n}\n\n.docs-page__cta p {\n  margin: 0 0 8px;\n  color: var(--color-text-secondary);\n  line-height: 1.55;\n  text-transform: uppercase;\n  letter-spacing: 0.07em;\n  font-size: 0.72rem;\n  font-weight: 700;\n}\n\n.docs-page__cta-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  flex-shrink: 0;\n}\n\n.docs-page__button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 38px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 8px;\n  padding: 0 14px;\n  color: var(--color-text-primary);\n  background: var(--color-bg-input);\n  text-decoration: none;\n  font-size: 0.9rem;\n  font-weight: 700;\n}\n\n.docs-page__button:hover {\n  background: var(--color-bg-user-bubble);\n}\n\n.docs-page__button--secondary {\n  background: transparent;\n  color: var(--color-text-secondary);\n}\n\n@media (max-width: 980px) {\n  .docs-page__quick-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .docs-page__layout {\n    grid-template-columns: 1fr;\n  }\n\n  .docs-page__toc {\n    position: static;\n    order: -1;\n  }\n\n  .docs-page__toc-list {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 680px) {\n  .docs-page {\n    padding: 22px 14px 72px;\n  }\n\n  .docs-page__hero,\n  .docs-page__article,\n  .docs-page__cta {\n    border-radius: 14px;\n    padding: 22px;\n  }\n\n  .docs-page__quick-grid,\n  .docs-page__toc-list {\n    grid-template-columns: 1fr;\n  }\n\n  .docs-page__layout {\n    gap: 16px;\n  }\n\n  .docs-page__cta {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n\n  .docs-page__cta-actions {\n    width: 100%;\n  }\n\n  .docs-page__button {\n    flex: 1 1 auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
